import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Sidebar from "./Sidebar";
import { useAuthStore } from "../../store/useAuthStore";
import BDWorkspaceLayout from "./BDWorkspaceLayout";
import { useSidebarCollapsed } from "../../hooks/useSidebarCollapsed";

const DashboardLayout = () => {
  const { authUser }: any = useAuthStore();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { collapsed, toggle } = useSidebarCollapsed("cre-admin-sidebar");

  // Business Developers get the new Material 3 workspace chrome.
  // Admin / Client keep the existing layout untouched.
  if (authUser?.role === "Business Developer") {
    return <BDWorkspaceLayout />;
  }

  return (
    <div className="flex min-h-screen overflow-x-hidden">

      <Sidebar
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
        collapsed={collapsed}
        onToggle={toggle}
      />

      {mobileOpen && (
        <div
          onClick={() => setMobileOpen(false)}
          className="fixed inset-0 z-40 bg-slate-900/50 backdrop-blur-sm lg:hidden"
          aria-hidden="true"
        />
      )}

      <main className={`flex-1 min-h-screen min-w-0 transition-[margin] duration-300 ${collapsed ? "lg:ml-20" : "lg:ml-56 2xl:ml-64"}`}>

        <div className="lg:hidden fixed top-0 left-0 right-0 z-30 h-14 flex items-center justify-between px-4 bg-[#0b2447] text-white border-b border-white/10">
          <button
            onClick={() => setMobileOpen((v) => !v)}
            className="p-2 -ml-2 rounded-lg hover:bg-white/10 transition"
            aria-label="Toggle navigation"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#2e9bff] to-[#0b5fd6] grid place-items-center">
              <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4">
                <circle cx="9" cy="12" r="5.5" stroke="white" strokeWidth="2" opacity="0.7" />
                <circle cx="15" cy="12" r="5.5" stroke="white" strokeWidth="2" />
              </svg>
            </div>
            <span className="text-[15px] font-extrabold tracking-tight">Omni Workspace</span>
          </div>
          <div className="w-9" />
        </div>

        <div className="lg:hidden h-14" />

        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
